// extracted by mini-css-extract-plugin
export default {"warningWrapper":"DeleteScenarioModal_warningWrapper__-1B6p","list":"DeleteScenarioModal_list__8Hcu4","warning":"DeleteScenarioModal_warning__mnwST"};